/*
  gift-cart.js — coloca o brinde escolhido no carrinho da Shopify, para ele
  seguir junto no checkout da CartPanda.

  Por que existe: o snippet da CartPanda (snippets/cartxCheckoutSnippet.liquid)
  troca o botão de finalizar por um próprio; no clique ele lê o /cart.json,
  envia o carrinho inteiro para a CartPanda e redireciona. O checkout só
  recebe as LINHAS do carrinho — o card "Brinde desbloqueado" era só visual,
  então o brinde nunca chegava.

  Regra, aplicada na carga da página, a cada mudança de carrinho (evento
  cartUpdate do tema), na troca de brinde e no clique de finalizar:
  - produto que libera no carrinho + promoção ativa: exatamente 1 unidade do
    brinde escolhido e nenhuma do outro;
  - caso contrário: nenhuma unidade de brinde.

  - O brinde entra com o preço do produto; o desconto automático da
    CartPanda zera o valor no checkout.
  - A linha do brinde fica escondida na lista do carrinho, fora da contagem
    do ícone e fora do total exibido (snippets/gift-cart-lines.liquid). A
    cliente só vê o card.
  - O clique de finalizar espera uma sincronização antes de seguir: a
    CartPanda lê o /cart.json na hora do clique.
*/

(function () {
  'use strict';

  if (window.giftCart) return;

  var noConfig = document.getElementById('gift-cart-config');
  if (!noConfig) return;

  var cfg = JSON.parse(noConfig.textContent);
  var FONTE = 'gift-cart';
  var FINALIZAR = '.cartx_check_mainBtn, button[name="checkout"], input[name="checkout"]';
  var fila = Promise.resolve();
  var liberado = false;

  function rota(nome, padrao) {
    return (window.routes && window.routes[nome]) || padrao;
  }

  function enviar(endereco, corpo) {
    corpo.sections = 'cart-icon-bubble';
    corpo.sections_url = window.location.pathname;
    return fetch(endereco + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (resposta) {
      if (!resposta.ok) throw new Error(endereco + ' ' + resposta.status);
      return resposta.json();
    });
  }

  /* o que mudar no carrinho para ele seguir a regra */
  function planejar(carrinho) {
    var itens = carrinho.items || [];
    var temGatilho = itens.some(function (item) {
      return item.product_id === cfg.gatilho;
    });
    var escolhido = cfg.brindes[0];
    var atributo = carrinho.attributes ? carrinho.attributes[cfg.chave] : null;
    if (cfg.escolha && cfg.brindes[1] && atributo === cfg.brindes[1].titulo) escolhido = cfg.brindes[1];

    var plano = { updates: {}, adicionar: null, removeu: false };
    cfg.brindes.forEach(function (brinde) {
      var quer = temGatilho && cfg.ativo && brinde === escolhido ? 1 : 0;
      var linhas = itens.filter(function (item) {
        return item.variant_id === brinde.variante;
      });
      linhas.forEach(function (linha, n) {
        /* limite de 1 unidade, numa linha só */
        var alvo = n === 0 ? quer : 0;
        if (linha.quantity === alvo) return;
        plano.updates[linha.key] = alvo;
        if (alvo === 0) plano.removeu = true;
      });
      if (quer && !linhas.length) plano.adicionar = brinde.variante;
    });
    return plano;
  }

  function repintarIcone(sections) {
    var alvo = document.getElementById('cart-icon-bubble');
    var html = sections && sections['cart-icon-bubble'];
    if (!alvo || !html) return;
    var fonte = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
    if (fonte) alvo.innerHTML = fonte.innerHTML;
  }

  function aplicar() {
    return fetch(rota('cart_url', '/cart') + '.js')
      .then(function (resposta) {
        return resposta.json();
      })
      .then(function (carrinho) {
        var plano = planejar(carrinho);
        var passos = Promise.resolve(null);

        if (Object.keys(plano.updates).length) {
          passos = passos.then(function () {
            return enviar(rota('cart_update_url', '/cart/update'), { updates: plano.updates });
          });
        }
        if (plano.adicionar) {
          passos = passos.then(function () {
            return enviar(rota('cart_add_url', '/cart/add'), { items: [{ id: plano.adicionar, quantity: 1 }] });
          });
        }

        return passos.then(function (resposta) {
          if (!resposta) return;
          repintarIcone(resposta.sections);
          /* Remover pode esvaziar o carrinho visível: o drawer precisa
             re-renderizar. Adicionar ou trocar o brinde não muda a tela. */
          if (plano.removeu && typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: FONTE });
          }
        });
      });
  }

  /* uma sincronização por vez; cada uma relê o carrinho */
  function sincronizar() {
    fila = fila.then(aplicar).catch(function (erro) {
      console.warn('[gift-cart] brinde não sincronizado', erro);
    });
    return fila;
  }

  /* Clique em finalizar (botão da CartPanda ou o nativo): segura, garante
     o brinde no carrinho e repete o clique. */
  document.addEventListener(
    'click',
    function (evento) {
      var botao = evento.target && evento.target.closest ? evento.target.closest(FINALIZAR) : null;
      if (!botao) return;
      if (liberado) {
        liberado = false;
        return;
      }
      evento.preventDefault();
      evento.stopImmediatePropagation();
      sincronizar().then(function () {
        var alvo = botao.isConnected
          ? botao
          : document.querySelector('.cartx_check_mainBtn') || document.querySelector(FINALIZAR);
        if (!alvo) return;
        liberado = true;
        alvo.click();
      });
    },
    true
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evento) {
      if (!evento || evento.source !== FONTE) sincronizar();
    });
  }

  window.giftCart = { sincronizar: sincronizar };
  sincronizar();
})();
